import {connect} from "react-redux"
import {createSelector} from "reselect"
import State from "../../ducks/state"
import {RECENT_SEARCHES_DEFAULT_ITEMS} from "../../config/constants"

const itemsSelector = createSelector(
    (state: State) => state.recents.queryIds,
    (state: State) => state.request.siteUrl,
    (state: State) => state.request.cleanSiteUrl,
    (state: State) => state.settings.isTpSuperLite,
    (queryIds: string[], siteUrl: string, cleanSiteUrl: string, isTpSuperLite: boolean) =>
        queryIds
            .slice()
            .map(item => ({
                item,
                url: `${isTpSuperLite ? cleanSiteUrl : siteUrl}/search?w=${encodeURIComponent(item)}`,
            }))
            .reverse(),
)

const limitRecentSearchesSelector = createSelector(
    itemsSelector,
    (state: State) => {
        const {enrichedSearchEnabled, recentSearchesMaxItems, enableRecentSearches} = state.settings
        const recentSearchItems = enrichedSearchEnabled
            ? recentSearchesMaxItems.enriched
            : recentSearchesMaxItems.simple
        return enableRecentSearches ? recentSearchItems : RECENT_SEARCHES_DEFAULT_ITEMS
    },
    (items: {item: string; url: string}[], MaxItems: number) => items.slice(0, MaxItems),
)

export const mapStateToProps = (state: State) => {
    const {
        text: {
            recentSearches: {enriched},
        },
        template,
    } = state

    const limitRecentSearches = limitRecentSearchesSelector(state)

    return {
        items: limitRecentSearches,
        typedCharacters: state.search.typedCharacters,
        text: enriched,
        templating: template,
    }
}

export default connect(mapStateToProps)
